import { render, staticRenderFns } from "./BatchInvoice.vue?vue&type=template&id=a90a51e0&scoped=true"
import script from "./BatchInvoice.vue?vue&type=script&lang=js"
export * from "./BatchInvoice.vue?vue&type=script&lang=js"
import style0 from "./BatchInvoice.vue?vue&type=style&index=0&id=a90a51e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90a51e0",
  null
  
)

export default component.exports